import { IsInt, IsNotEmpty, IsNumber, IsPositive } from 'class-validator';

export class CreateApronDto {
  @IsInt()
  @IsNotEmpty()
  merchantId: number;

  @IsInt()
  @IsNotEmpty()
  employeeId: number;

  @IsInt()
  @IsNotEmpty()
  deviceId: number;

  @IsInt()
  @IsNotEmpty()
  currencyId: number;

  @IsNumber()
  @IsNotEmpty()
  @IsPositive()
  amount: number; // Stored in 'requestedAmount' initially
}